<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import PaymentsTableTab from '@/components/payments/PaymentsTableTab.vue';
import type { PaymentsTabId } from '@/composables/usePayments';
import { ALL_STATUSES } from '@/services/paymentStatus';

defineProps<{
    tabId?: PaymentsTabId;
}>();
</script>

<template>
    <!-- PHASE 2: UNCOMMENT THIS WHEN PHASE 2 STARTS — restore action-mode="dynamic". -->
    <PaymentsTableTab
        :status-options="ALL_STATUSES"
        empty-description="No payments match your current filters."
        action-mode="none"
    />
</template>
